"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resource_1 = require("../resource");
var user = /** @class */ (function (_super) {
    tslib_1.__extends(user, _super);
    function user() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.route = '/user';
        return _this;
    }
    user.prototype.whoami = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: "/whoami" })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     *
     * @param {Array<string> | string} id - id/s of users to retrieve.
     * @returns {Promise<Array<User>>}
     */
    user.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "" + this.route,
                            params: { id: Array.isArray(id) ? id.join(',') : id }
                        })];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results.users];
                }
            });
        });
    };
    // TODO(Reece): retrieve the newly created user and return that instead of a ID. 
    /**
     * Create a new User in the Bugzilla database.
     *
     * @param {User} user User object to be created. Required fields are defined in the User interface.
     * @returns {number} Return the ID of the created Bug.
     */
    user.prototype.create = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "" + this.route,
                            method: 'POST',
                            data: user
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.id];
                }
            });
        });
    };
    return user;
}(resource_1.resource));
exports.user = user;



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/users/user.js
// module id = 988
// module chunks = 0